export const payload = {
  receiveMutation: 'RECEIVE_LOCATIONS',
  receivingMutation: 'RECEIVING_LOCATIONS',
  receiveMetadataMutation: 'RECEIVE_LOCATION_METADATA',
  receiveFailureMutation: 'RECEIVE_LOCATION_FAILURE',
  savingMutation: 'SAVING_LOCATION',
  saveFailureMutation: 'SAVING_LOCATION_FAILURE',
  incrementMutation: 'INCREMENT_LOCATION_COUNT',
  updatingMutation: 'UPDATING_LOCATION',
  updateFailureMutation: 'UPDATING_LOCATION_FAILURE',
  deleteMutation: 'DELETE_LOCATION',
  deletingMutation: 'DELETING_LOCATION',
  deleteFailureMutation: 'DELETING_LOCATION_FAILURE',
  resetMetaMutation: 'RESET_LOCATION_META',
  clearMutation: 'CLEAR_LOCATION_STATE',
  moduleName: 'location',
  endpoint: 'locations',
  defaultModelGetter: 'getDefaultLocation',
  searchableFields: ['code', 'name', 'description']
}
